/* eslint-disable no-undef */
import BaseModel from './base-modeles/base-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IGapModel } from '@src/slide/domain/ui-model/element-modeles/Interface/gap-model.interface';

// 左侧幻灯片列表间隙的model
class GapModel extends BaseModel implements IGapModel {
    public gapIndex = -1;
    public isFromMasterLayout = false;

    public constructor(props) {
        super(props);
        this.type = UIModelType.GAP;
        this.isFromMasterLayout = props.isFromMasterLayout;
        if (props?.gapIndex !== undefined) {
            this.gapIndex = props.gapIndex;
        }
    }
}

export default GapModel;
